<template>
  <!-- the #js-page-content id is needed for some plugins to initialize -->
  <main id="js-page-content" role="main" class=" page-content" style="background:#dddae4" data-app >
    <div v-if="selectedProcess==null" class="d-flex justify-center align-center buscador">
      <v-select
        v-model="selectedProcess"
        return-object
        :loading="loadingProcesses"
        :items="processes"
        item-text="text"
        item-value="id"
        label="Proceso"
        @change="select_process"
        hint="Comienza la búsqueda"
        persistent-hint
        prepend-icon="search"
        dense
        light>
      </v-select>
    </div>
    <div v-else>
      <v-row>
        <v-col md="6">
          <v-select
            v-model="selectedProcess"
            return-object
            :loading="loadingProcesses"
            :items="processes"
            item-text="text"
            item-value="id"
            label="Colección"
            @change="select_process"
            hide-details
            prepend-icon="search"
            dense
            light>
          </v-select>
        </v-col>
        <v-col md="3" class="pl-4 pr-3">
          <v-menu
            bottom
            left
            :close-on-content-click="false"
            v-model="menu"
            light
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                style="min-width:100%"
                class="black--text"
                light
              >
                {{ $route.query.from!=undefined && $route.query.to!=undefined ? $route.query.from +' - '+ $route.query.to : 'Ingrese el periodo de tiempo' }}
              </v-btn>
            </template>
            <v-card>
              <v-date-picker
                v-model="fechas"
                range
                no-title
                @change="ModificarFecha"
              ></v-date-picker>
            </v-card>

          </v-menu>
        </v-col>
        <v-col md="3" style="cursor:pointer;" @click.stop="switchTweets=!switchTweets; actualizar();">
          <v-btn
            v-model="switchTweets"
            width="47%"
            class="mx-1"
            color="secondary"
            :disabled="switchTweets"
            light
          >
            Tweets
          </v-btn>
          <v-btn
            v-model="switchTweets"
            width="47%"
            class="mx-1"
            color="accent"
            :disabled="!switchTweets"
            light
          >
            Retweets
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="selectedProcess!=null && !donut_loading && !line_loading && !word_loading && !bubble_loading && !bubble_pack_loading && !map_loading">
        <v-row no-gutters>
          <v-col md="3" v-for="(item,index) in dataFacts" :key="'slide_col_'+index" class="px-3">
            <v-card
            :key="'slide_card_'+index"
            height="100"
            width="300"
            light>
              <h3 class="ml-3 mt-3 px-2">
                <small class="mb-0 pt-4">{{item.title}}</small>
                <p class="ml-5">
                  {{data_counts[index].toLocaleString('de')}}
                </p>
              </h3>
              <i class="position-absolute pos-right pos-bottom opacity-60 mb-0 mr-0" :class="item.icon" style="font-size:6rem" :style="{ color: item.color }"></i>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="4" @click="donutDisplayed = !donutDisplayed" style="cursor:pointer;">
            <v-card
            v-if="!donutDisplayed"
            class="mx-auto rounded-card"
            height="345px"
            light>
              <h4 class="gr-title mb-2">Análisis de Sentimientos ({{!switchTweets ? 'Tweets' : 'Retweets'}})</h4>
              <div class="d-flex align-center" style="min-height:315px">
                <div class="mx-3 px-1 my-2" height="220px">
                  <v-row class="my-2 d-flex align-center">
                    <v-col md="4" class="mt-4">
                      <img :src="require(`@/assets/happy.png`)" width="100%">
                      <h2 class="text-center my-3">{{((donut_series[0]/donut_series.reduce((a, b) => {return a + b;}))*100).toFixed(1)+'%'}}</h2>
                    </v-col>
                    <v-col md="4" class="mt-4">
                      <img :src="require(`@/assets/neutral.png`)" width="100%">
                      <h2 class="text-center my-3">{{((donut_series[2]/donut_series.reduce((a, b) => {return a + b;}))*100).toFixed(1)+'%'}}</h2>
                    </v-col>
                    <v-col md="4" class="mt-4">
                      <img :src="require(`@/assets/angry.png`)" width="100%">
                      <h2 class="text-center my-3">{{((donut_series[1]/donut_series.reduce((a, b) => {return a + b;}))*100).toFixed(1)+'%'}}</h2>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card>
            <v-card v-else class="mx-auto rounded-card" height="345px" light>
              <h4 class="gr-title">Análisis de Sentimientos ({{!switchTweets ? 'Tweets' : 'Retweets'}})</h4>
              <donut-chart :series="donut_series"></donut-chart>
            </v-card>
          </v-col>
          <v-col md="8">
            <v-card
            class="mx-auto rounded-card"
            height="345px"
            light>
              <h4 class="gr-title">Evolución de {{!switchTweets ? 'Tweets' : 'Retweets'}}</h4>
              <line-chart :title="!switchTweets ? 'Cantidad de Tweets' : 'Cantidad de Retweets'" :series="line_series" :categories="line_categories"></line-chart>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="8">
            <v-card
            class="mx-auto px-1 rounded-card"
            height="345px"
            light>
              <h4 class="gr-title">Análisis de influencers y sentimientos</h4>
              <bubble-chart :series="bubble_series"></bubble-chart>
            </v-card>
          </v-col>
          <v-col md="4">
            <v-card class="mx-auto rounded-card" height="345px" light>
              <h4 class="gr-title">Palabras Destacadas</h4>
              <word-cloud-chart :series="word_series_with_type"></word-cloud-chart>
            </v-card>
          </v-col>
        </v-row>

         <v-row>
          <v-col md="4">
            <v-card class="mx-auto rounded-card" height="345px" light>
              <h4 class="gr-title">Tweets Destacados</h4>
              <bubble-pack-chart :series="bubble_pack_series"></bubble-pack-chart>
            </v-card>
          </v-col>
          <v-col md="8">
            <v-card class="mx-auto rounded-card" height="345px" light>
              <h4 class="gr-title">Tweets Georeferenciados</h4>
              <map-chart :process_id="selectedProcess.id"></map-chart>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

  </main>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue';
import MapChart from '@/components/charts/MapChart.vue';
import DonutChart from '@/components/charts/DonutChart.vue';
import BubbleChart from '@/components/charts/BubbleChart.vue';
import BubblePackChart from '@/components/charts/BubblePackChart.vue';
import WordCloudChart from '@/components/charts/WordCloudChart.vue';
import apiExtract from "@/api/modules/extract";
import apiAnalitics from "@/api/modules/analitics";

export default {
  name: 'Home',
  components: {
    LineChart,
    MapChart,
    BubbleChart,
    DonutChart,
    BubblePackChart,
    WordCloudChart
  },
  computed:{
    word_series_with_type(){
      return [{type: 'wordcloud', data: this.word_series, name:"Top Palabras"}]
    },
    fechas(){
      return [this.from, this.to]
    },
  },
  data(){
    return{
      from:'',
      to:'',
      data_detail:[],
      locale:'es',
      switchTweets:false,
      donutDisplayed:false,
      menu:false,
      begin:'2019-01-01',
      data_counts:['Cargando...','Cargando...','Cargando...','Cargando...'],
      donut_series:[0,0,0],
      line_series:[{
        name: "Positivos",
        data: [0]
      },{
        name: "Negativos",
        data: [0]
      },{
        name: "Neutros",
        data: [0]
      }],
      line_categories:['0'],
      selectedProcess: null ,
      processes:[],
      loadingProcesses:true,
      word_series:[],
      bubble_series:{"negatives":[],"neutres":[],"positives":[]},
      bubble_pack_series:[],
      dataFacts:
      [
        {
          title:'Tweets Extraidos',
          icon: 'fab fa-twitter',
          color: '#1da1f2'
        },
        {
          title:'Cuentas Relacionadas',
          icon: 'fal fa-user',
          color: ''
        },
        {
          title:'Menciones',
          icon: 'fal fa-at',
          color: this.$vuetify.theme.currentTheme.success
        },
        {
          title:'Retweets',
          icon: 'fal fa-reply',
          color: this.$vuetify.theme.currentTheme.warning
        },
      ],
      count_loading: true,
      donut_loading: true,
      line_loading: true,
      word_loading: true,
      bubble_loading: true,
      bubble_pack_loading: true,
      map_loading: true,

    }
  },
  mounted(){
    apiExtract.getProcesses()
    .then((resp)=>{
        if(resp.status){
            this.processes = resp.processes;
            this.loadingProcesses = false;
            this.selectedProcess = (this.$route.query.selectedProcess == null ? null : this.processes.filter( x => x.id == this.$route.query.selectedProcess)[0])
            if (this.selectedProcess != null && this.$route.query.from != undefined && this.$route.query.to != undefined) {
              this.from=this.$route.query.from
              this.to=this.$route.query.to
              this.select_process()
            }
        }
    })
  },
  methods:{
    actualizar(){

      this.count_loading = true
      this.donut_loading = true
      this.line_loading = true
      this.word_loading = true
      this.bubble_loading = true
      this.bubble_pack_loading = true
      this.map_loading = true
      apiAnalitics.getTotalsHashsTweetsAccounts(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
        .then((res)=>{
          if(res.status){
            this.data_counts = [res.data.totals.total_tweets, res.data.totals.total_accounts, res.data.totals.total_hashs,  res.data.totals.total_retweets]
            this.count_loading = false
          }
        })
        .catch((err)=>{
          console.error(err);
        })

      if (this.switchTweets) {
        apiAnalitics.getTotalSentimentsRetweets(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            if(res.status){
              this.donut_series = [res.data.positives,res.data.negatives,res.data.neutres]
              this.donut_loading = false
            }
          })
          .catch((err)=>{
            console.error(err);
          })
      }else{
        apiAnalitics.getTotalSentiments(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            if(res.status){
              this.donut_series = [res.data.positives,res.data.negatives,res.data.neutres]
              this.donut_loading = false
            }
          })
          .catch((err)=>{
            console.error(err);
          })
      }




      if(this.switchTweets){
        apiAnalitics.getDatesEvolutionRetweet(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            if(res.status){
              this.line_series = [{
                name: "Positivos",
                data: res.positives.map((x)=>{return x.retweets.value})
              },{
                name: "Negativos",
                data: res.negatives.map((x)=>{return x.retweets.value})
              },{
                name: "Neutros",
                data: res.neutres.map((x)=>{return x.retweets.value})
              }]
              let x=0
              let i_p=Object.keys(res)[0]
              for (let i of Object.keys(res)){
                if(x<res[i].length){
                  x=res[i].length
                  i_p=i
                }
              }
              this.line_categories=res[i_p].map((x)=>{return x.key})
            }
            this.line_loading = false
          })
          .catch((err)=>{
            console.error(err);
          })
      }else{
        apiAnalitics.getDatesEvolutionSentiment(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            if(res.status){
              this.line_series = [{
                name: "Positivos",
                data: res.positives.map((x)=>{return x.doc_count})
              },{
                name: "Negativos",
                data: res.negatives.map((x)=>{return x.doc_count})
              },{
                name: "Neutros",
                data: res.neutres.map((x)=>{return x.doc_count})
              }]
              let x=0
              let i_p=Object.keys(res)[0]
              for (let i of Object.keys(res)){
                if(x<res[i].length){
                  x=res[i].length
                  i_p=i
                }
              }
              this.line_categories=res[i_p].map((x)=>{return x.key})
            }
            this.line_loading = false
          })
          .catch((err)=>{
            console.error(err);
          })
      }


        this.word_series=[]
        apiAnalitics.getTopWords(this.selectedProcess.id, "p", this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            this.word_series=this.word_series.concat(res.data.slice(0,5).map((x)=>{return {color:"#00E396",weight:x.doc_count,name:x.key}}))
          })
          .catch((err)=>{
            console.error(err);
          })

        apiAnalitics.getTopWords(this.selectedProcess.id, "n", this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            this.word_series=this.word_series.concat(res.data.slice(0,5).map((x)=>{return {color:"#FF4560",weight:x.doc_count,name:x.key}}))
          })
          .catch((err)=>{
            console.error(err);
          })

        apiAnalitics.getTopWords(this.selectedProcess.id, "e", this.$route.query.from, this.$route.query.to)
          .then((res)=>{
            this.word_series=this.word_series.concat(res.data.slice(0,5).map((x)=>{return {color:"#FEB019",weight:x.doc_count,name:x.key}}))
            this.word_loading= false
          })
          .catch((err)=>{
            console.error(err);
          })

        apiAnalitics.getInfluencersInfoRetFolSentiment(this.selectedProcess.id, this.$route.query.from, this.$route.query.to)
          .then((resp)=>{
              if(resp.status){
                this.bubble_series=resp
                this.bubble_loading= false
              }
          })

          apiAnalitics.getTop3Tweets(this.selectedProcess.id, this.type, this.$route.query.from, this.$route.query.to)
            .then((resp)=>{
                if(resp.status){
                  var posi = {
                    name: 'Positivos',
                    data: resp.data.positivos.map((x)=>{return {name:x._source.data_productor+'    '+x._source.texto, value:x._source.retweets}})
                  }
                  var nega = {
                    name: 'Negativos',
                    data: resp.data.negativos.map((x)=>{return {name:x._source.data_productor+'    '+x._source.texto, value:x._source.retweets}})
                  }
                  var neut = {
                    name: 'Neutros',
                    data: resp.data.neutros.map((x)=>{return {name:x._source.data_productor+'    '+x._source.texto, value:x._source.retweets}})
                  }

                  this.bubble_pack_series =[]
                  if(posi.data.length!=0){
                    this.bubble_pack_series=this.bubble_pack_series.concat([posi])
                  }
                  if(nega.data.length!=0){
                    this.bubble_pack_series=this.bubble_pack_series.concat([nega])
                  }
                  if(neut.data.length!=0){
                    this.bubble_pack_series=this.bubble_pack_series.concat([neut])
                  }
                  this.bubble_pack_loading= false
                }
            })



        this.map_loading= false
    },
    select_process(){
      this.$router.push({ query: Object.assign({}, this.$route.query, {
        to: this.selectedProcess.fecha_fin,
        from: this.selectedProcess.fecha_inicio,
        selectedProcess: this.selectedProcess.id
      }) })
      this.actualizar()
    },
    ModificarFecha(values) {
      this.$router.push({ query: Object.assign({}, this.$route.query, {
        to: values[0].slice(0,10),
        from: values[1].slice(0,10)
      }) })
      this.menu=false
      this.actualizar()
    }
  },

}
</script>
<style>
.bubbles {
  stroke-width: 1.5px;
  stroke: white;
  opacity: .8
}
.bubbles:hover {
  stroke: black;
}
.gr-title{
  padding: 6px 15px;
  margin: 0;
}
.rounded-card{
  border-radius: 10px !important;
}
.buscador{
  height: 450px;
  padding: 0 30%;
}
</style>
